import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/me/info/code.png';
import _imports_1 from '../../assets/image/me/info/comment.png';
import _imports_2 from '../../assets/image/me/info/sz.png';
import _imports_3 from '../../assets/image/me/info/exit.png';
import _imports_4 from '../../assets/image/me/info/dj.png';
import _imports_5 from '../../assets/image/sright.png';
import _imports_6 from '../../assets/image/me/info/cz.png';
import _imports_7 from '../../assets/image/me/info/tx.png';
import _imports_8 from '../../assets/image/close.png';
const _withScopeId = n => (_pushScopeId("data-v-3f11a007"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-main-me"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "height-bg"
}, null, -1));
const _hoisted_3 = {
  class: "tk-me-head"
};
const _hoisted_4 = {
  key: 0,
  class: "tk-me-NotLogin"
};
const _hoisted_5 = {
  class: "tk-logo"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "tk-login-title"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请登录或者注册后查看", -1));
const _hoisted_9 = {
  class: "tk-me-login"
};
const _hoisted_10 = {
  key: 1,
  class: "tk-me-login"
};
const _hoisted_11 = {
  class: "tk-me-login-head flex-between"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "邀请码", -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = {
  class: "tk-head-info"
};
const _hoisted_16 = {
  key: 0,
  class: "tips"
};
const _hoisted_17 = {
  class: "tk-login-info flex-between"
};
const _hoisted_18 = {
  class: "tk-info"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "tk-data"
};
const _hoisted_21 = {
  class: "tk-data-name"
};
const _hoisted_22 = {
  class: "tk-grade flex-between"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的主页", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_26 = [_hoisted_24, _hoisted_25];
const _hoisted_27 = {
  class: "tk-login-money flex-between"
};
const _hoisted_28 = {
  class: "tk-money"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-money-name"
}, "金币", -1));
const _hoisted_30 = {
  class: "tk-money-num"
};
const _hoisted_31 = {
  class: "tk-money-icon"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "充值", -1));
const _hoisted_34 = [_hoisted_32, _hoisted_33];
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "提现", -1));
const _hoisted_37 = [_hoisted_35, _hoisted_36];
const _hoisted_38 = {
  class: "tk-me-member-box"
};
const _hoisted_39 = {
  class: "tk-menber-title"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  class: "icon"
};
const _hoisted_42 = ["src"];
const _hoisted_43 = {
  class: "name"
};
const _hoisted_44 = {
  class: "prompt"
};
const _hoisted_45 = ["onClick"];
const _hoisted_46 = {
  class: "lottery-title"
};
const _hoisted_47 = ["src"];
const _hoisted_48 = {
  class: "loottery-tiems"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下期开奖时间：", -1));
const _hoisted_50 = {
  class: "i"
};
const _hoisted_51 = {
  class: "tk-botton"
};
const _hoisted_52 = {
  class: "tk-main-QEcode"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1));
const _hoisted_54 = [_hoisted_53];
const _hoisted_55 = {
  class: "tk-exit-name"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-exit-title"
}, "选择聊天室", -1));
const _hoisted_57 = {
  class: "tk-exit-from"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "新版六合聊天室", -1));
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, null, -1));
const _hoisted_60 = [_hoisted_58, _hoisted_59];
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "旧版六合聊天室", -1));
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, null, -1));
const _hoisted_63 = [_hoisted_61, _hoisted_62];
import { onBeforeMount, reactive, toRefs } from 'vue';
import addGameUser from '@/components/me/addGameUser.vue';
import QRcode from '@/components/me/QRcode.vue';
import Dialog from '@/components/mode/message';
import { useStore } from 'vuex';
import { getUserInfo } from '@/utils/https/me';
import { nextLottery, getMessageBadge } from '@/utils/https/https';
import { roomList } from '@/utils/https/wechar';
import { getCurrentInstance } from 'vue';

import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    let listRoom = [];
    let data = reactive({
      box: [{
        title: '我的频道',
        data: [{
          name: '我的推广',
          image: require('@/assets/image/me/tg.png'),
          path: 'c'
        }, {
          name: '我的收藏',
          image: require('@/assets/image/me/sc.png'),
          path: '/me/collect'
        }, {
          name: '我的评论',
          image: require('@/assets/image/me/pl.png'),
          path: '/me/comment'
        }, {
          name: '我的关注',
          image: require('@/assets/image/me/gz.png'),
          path: '/me/follow'
        }, {
          name: '我的粉丝',
          image: require('@/assets/image/me/fs.png'),
          path: '/me/fans'
        }, {
          name: '我的点赞',
          image: require('@/assets/image/me/dz.png'),
          path: '/me/upvote'
        }, {
          name: '我的小黑屋',
          image: require('@/assets/image/me/xhw.png'),
          path: '/me/room'
        }, {
          name: '我的黑名单',
          image: require('@/assets/image/me/hmd.png'),
          path: '/me/blacklist'
        }]
      }, {
        title: '必备工具',
        data: [{
          name: '活动中心',
          image: require('@/assets/image/me/hdzx.png'),
          path: '/me/activity'
        }, {
          name: '邀请好友',
          image: require('@/assets/image/me/yqhy.png'),
          path: '/me/invite'
        }, {
          name: '聊天室',
          image: require('@/assets/image/me/lts.png'),
          path: 'wechat'
        }, {
          name: '用户等级',
          image: require('@/assets/image/me/yhdj.png'),
          path: '/me/grade'
        }]
      }, {
        title: '排行榜',
        data: [{
          name: '粉丝排行榜',
          image: require('@/assets/image/me/fsphb.png'),
          path: '/me/ranking/fans'
        }, {
          name: '等级排行榜',
          image: require('@/assets/image/me/djphb.png'),
          path: '/me/ranking/grade'
        }, {
          name: '分享排行榜',
          image: require('@/assets/image/me/fxphb.png'),
          path: '/me/ranking/share'
        }, {
          name: '金币排行榜',
          image: require('@/assets/image/me/lwphb.png'),
          path: '/me/ranking/gift'
        }]
      }, {
        title: '平台信息',
        data: [{
          name: '平台设置',
          image: require('@/assets/image/me/ptsz.png'),
          path: 'sz'
        }, {
          name: '联系客服',
          image: require('@/assets/image/me/lxkf.png'),
          path: '/me/kf'
        }, {
          name: '举报记录',
          image: require('@/assets/image/me/jbzl.png'),
          path: '/me/report'
        }, {
          name: '清除缓存',
          image: require('@/assets/image/me/qlhc.png'),
          path: 'b'
        }]
      }],
      lotteryType: [{
        icon: require('../../assets/image/major/provice/2017.png'),
        name: '港彩',
        id: '1',
        times: '2024年06月07日  21点30分'
      }, {
        icon: require('../../assets/image/major/provice/2031.png'),
        name: '新澳彩',
        id: '2',
        times: '2024年06月07日  21点30分'
      },
      // {icon:require('../../assets/image/major/provice/2018.png'),name:'台彩',id:'3',times:'2024年06月07日  21点30分'},
      // {icon:require('../../assets/image/major/provice/2032.png'),name:'新彩',id:'4',times:'2024年06月07日  21点30分'},
      //{icon:require('../../assets/image/major/provice/2031.png'),name:'天澳彩',id:'5',times:'2024年06月07日  22点30分'},
      {
        icon: require('../../assets/image/major/provice/2031.png'),
        name: '老澳',
        id: '7',
        times: '2024年06月07日  21点30分'
      }, {
        icon: require('../../assets/image/major/provice/2031.png'),
        name: '快乐八',
        id: '6',
        times: '2024年06月07日  21点30分'
      }],
      codeShow: false,
      gameShow: false,
      userInfo: '',
      //用户数据
      https: process.env.VUE_APP_BASE_API_S,
      shows: false,
      lotteryTypes: localStorage.getItem('lotteryType'),
      roomShow: false,
      websiteName: JSON.parse(localStorage.getItem('config')) == null ? {
        name: '图库中心',
        login: require('../../assets/image/logo.png')
      } : JSON.parse(localStorage.getItem('config')),
      gameTitle: '',
      msg: 0,
      showss: false
    });
    let {
      box,
      codeShow,
      gameShow,
      userInfo,
      https,
      shows,
      lotteryType,
      lotteryTypes,
      roomShow,
      websiteName,
      gameTitle,
      showss
    } = toRefs(data);
    const router = useRouter();
    const $store = useStore(); //获取vuex
    onBeforeMount(() => {
      //

      data.msg = $store.state.msg;
      window.scrollTo(0, 0);
      if (localStorage.getItem('usetInfo') == null || localStorage.getItem('usetInfo') == undefined) {
        // getUserInfos()
      } else {
        data.userInfo = JSON.parse(localStorage.getItem('usetInfo'));
      }
      if (localStorage.getItem('Authorization') != null) {
        getUserInfos();
      }
      // nextLotterys()
      if (localStorage.getItem('Authorization') != null) {
        //获取消息 
        getMessageBadge().then(res => {
          if (res.status == 500) {
            return false;
          }
          if (res.data.status != 40000) {
            let msg = res.data.data.msg;
            $store.commit('msgadd', msg);
          }
        });
      }
    });
    // 接口请求 
    let list = reactive([{
      name: '香港六合聊天室',
      id: '1',
      selectIcon: require('@/assets/image/major/provice/2028.png')
    }, {
      name: '新澳门六合聊天室',
      id: '2',
      selectIcon: require('@/assets/image/major/provice/2015.png')
    }, {
      name: '台湾六合聊天室',
      id: '3',
      selectIcon: require('@/assets/image/major/provice/2029.png')
    }, {
      name: '新加坡六合聊天室',
      id: '4',
      selectIcon: require('@/assets/image/major/provice/2019.png')
    }, {
      name: '澳门六合聊天室',
      id: '5',
      selectIcon: require('@/assets/image/major/provice/2015.png')
    }]);
    let roomLists = () => {
      roomList().then(res => {
        list.length = 0;
        let datas = res.data.data;
        if (datas.length == 1) {
          data.showss = true;
          listRoom.push({
            title: datas[0].name,
            id: datas[0].id
          });
        } else if (datas.length == 0) {
          Dialog('暂无聊天列表');
        } else {
          gameShow.value = true;
        }
        datas.forEach((item, index) => {
          switch (item.id) {
            case 1:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('@/assets/image/major/provice/2028.png')
              });
              break;
            case 2:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('@/assets/image/major/provice/2015.png')
              });
              break;
            case 3:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('@/assets/image/major/provice/2029.png')
              });
              break;
            case 4:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('@/assets/image/major/provice/2019.png')
              });
              break;
            case 5:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('@/assets/image/major/provice/2015.png')
              });
              break;
            default:
              break;
          }
        });
        localStorage.setItem('room_info', JSON.stringify(list));
      });
    };
    let selecRooms = id => {
      if (id == 1) {
        router.push({
          path: '/wechat',
          query: {
            title: listRoom[0].title,
            id: listRoom[0].id
          }
        });
      } else {
        router.push({
          path: '/wechat/liuhe'
        });
      }
    };
    let getUserInfos = () => {
      getUserInfo().then(res => {
        if (res.status != 500) {
          let datas = res.data.data;
          data.userInfo = datas;
          localStorage.setItem('usetInfo', JSON.stringify(datas));
        } else {
          data.userInfo = '';
        }
      });
    };

    // let nextLotterys = ()=>{
    //     let nextLotterys = JSON.parse(localStorage.getItem('nextLottery'));
    //     if(nextLotterys==null || nextLotterys.tiems < Date.now()){
    //         nextLottery().then(res=>{//获取下一期的开奖数据
    //             if(res.status!=500){
    //                 let datas = res.data.data;
    //                 data.lotteryType.forEach((item,index) => {

    //                     item.times =  `${datas[index].lotteryTime}   ${datas[index].time}`
    //                     // data.lotteryType[index].times = `${item.lotteryTime}   ${item.time}`
    //                 });
    //                 let datab = {datas,tiems:Date.now() + 1000 * 60 * 30 }
    //                 localStorage.setItem('nextLottery',JSON.stringify(datab))
    //             }
    //         })
    //     }else{
    //         let datas =  nextLotterys.datas;
    //         data.lotteryType.forEach((item,index) => {
    //             item.times =  `${datas[index].lotteryTime}   ${datas[index].time}`
    //             // data.lotteryType[index].times = `${item.lotteryTime}   ${item.time}`
    //         });

    //     }
    // }

    //功能区域
    let selectLottery = id => {
      data.lotteryTypes = id;
      localStorage.setItem('lotteryTypes', id);
      localStorage.setItem('lotteryType', id);
      $store.commit('upLotteryCont', id);
    };
    let prompt = () => {
      //平台设置
      data.shows = false;
    };
    let QRcodeFun = () => {
      //显示二维码
      data.codeShow = true;
    };
    let czmoney = () => {
      if (data.userInfo.platforms_count == 0) {
        data.gameTitle = '您还没有平台游戏账号，请前往添加';
        data.gameShow = true;
      } else {
        router.push({
          path: '/me/purse/topup'
        });
      }
    };
    let txmoney = () => {
      if (data.userInfo.isset_fund_password != 0 && data.userInfo.platforms_count != 0) {
        router.push({
          path: '/me/purse/withdraw'
        });
      } else {
        if (data.userInfo.platforms_count == 0) {
          data.gameTitle = '您还没有平台游戏账号，请前往添加';
        } else {
          data.gameTitle = '您还没有添加平台资金密码，请前往添加';
        }
        data.gameShow = true;
      }
    };
    let setup = () => {
      //跳转设置页面
      router.push({
        path: '/me/setup'
      });
    };
    let login = () => {
      //跳转登陆页面
      router.push({
        path: '/login'
      });
    };
    let homepage = () => {
      router.push({
        path: '/userInfo',
        query: {
          id: data.userInfo.id
        }
      });
    };
    const {
      proxy
    } = getCurrentInstance();
    let navGeTo = path => {
      if (path == 'sz') {
        data.shows = true;
      } else if (path == 'c') {
        Dialog('开发中...');
      } else if (path == 'b') {
        Dialog('清除缓存成功,请刷新页面');
        // localStorage.clear();
        localStorage.removeItem('yearone');
        localStorage.removeItem('yearColor');
        localStorage.removeItem('config');
        localStorage.removeItem('lotteryNumber');
        localStorage.removeItem('notice');
        localStorage.removeItem('swiperImg');
        localStorage.removeItem('number_attr');
        localStorage.removeItem('room_info');
        localStorage.removeItem('materList');
        localStorage.removeItem('nextLottery');
        sessionStorage.clear();
        localStorage.removeItem('avList');
        // location.reload();
        proxy.$sayHello();
      } else if (path == 'wechat') {
        if (localStorage.getItem('room_info') != null) {
          list = JSON.parse(localStorage.getItem('room_info'));
          if (list.length == 1) {
            data.showss = true;
            listRoom.push({
              title: list[0].name,
              id: list[0].id
            });
            // router.push({
            //     path:'/wechat',
            //     query:{
            //         title:list[0].name,
            //         id:list[0].id
            //     }
            // })
          } else if (list.length == 0) {
            Dialog('暂无聊天列表');
          } else {
            data.roomShow = true;
          }
        } else {
          roomLists();
        }
      } else {
        router.push({
          path: path
        });
      }
    };
    let selecRoom = item => {
      //选择聊天室
      router.push({
        path: '/wechat',
        query: {
          title: item.name,
          id: item.id
        }
      });
    };
    let handleMessg = () => {
      router.push({
        path: '/notice'
      });
    };
    return (_ctx, _cache) => {
      const _component_botton = _resolveComponent("botton");
      const _component_van_overlay = _resolveComponent("van-overlay");
      const _component_wecharList = _resolveComponent("wecharList");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_unref(userInfo) == '' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        src: _unref(https) + _unref(websiteName).logo,
        alt: ""
      }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, "欢迎来到" + _toDisplayString(_unref(websiteName).name), 1), _hoisted_8]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_botton, {
        name: "登陆/注册",
        onClick: _unref(login)
      }, null, 8, ["onClick"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        class: "tk-tow-code",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(QRcodeFun) && _unref(QRcodeFun)(...args))
      }, _hoisted_14), _createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
        class: "comment",
        src: _imports_1,
        alt: "",
        onClick: _cache[1] || (_cache[1] = $event => _unref(handleMessg)())
      }), _createElementVNode("img", {
        class: "sz",
        src: _imports_2,
        alt: "",
        onClick: _cache[2] || (_cache[2] = (...args) => _unref(setup) && _unref(setup)(...args))
      }), _unref(data).msg > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
        src: _unref(userInfo).avatar == '' ? require('@/assets/image/logo.png') : _unref(https) + _unref(userInfo).avatar,
        alt: ""
      }, null, 8, _hoisted_19), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", null, _toDisplayString(_unref(userInfo).nickname), 1), _createElementVNode("img", {
        src: _imports_3,
        alt: "",
        onClick: _cache[3] || (_cache[3] = (...args) => _unref(setup) && _unref(setup)(...args))
      })]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("span", null, "V" + _toDisplayString(_unref(userInfo).level_grade), 1)])])]), _createElementVNode("div", {
        class: "tk-more",
        onClick: _cache[4] || (_cache[4] = (...args) => _unref(homepage) && _unref(homepage)(...args))
      }, _hoisted_26)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(userInfo).account_balance), 1)]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
        class: "tk-money-item",
        onClick: _cache[5] || (_cache[5] = (...args) => _unref(czmoney) && _unref(czmoney)(...args))
      }, _hoisted_34), _createElementVNode("div", {
        class: "tk-money-item",
        onClick: _cache[6] || (_cache[6] = (...args) => _unref(txmoney) && _unref(txmoney)(...args))
      }, _hoisted_37)])])]))]), _createElementVNode("div", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(box), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "tk-me-box",
          key: index
        }, [_createElementVNode("div", _hoisted_39, _toDisplayString(item.title), 1), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (items, indexs) => {
          return _openBlock(), _createElementBlock("li", {
            key: indexs,
            onClick: $event => _unref(navGeTo)(items.path)
          }, [_createElementVNode("div", _hoisted_41, [_createElementVNode("img", {
            src: items.image,
            alt: ""
          }, null, 8, _hoisted_42)]), _createElementVNode("div", _hoisted_43, _toDisplayString(items.name), 1)], 8, _hoisted_40);
        }), 128))])]);
      }), 128))])]), _createVNode(QRcode, {
        show: _unref(codeShow),
        "onUpdate:show": _cache[7] || (_cache[7] = $event => _isRef(codeShow) ? codeShow.value = $event : codeShow = $event)
      }, null, 8, ["show"]), _createVNode(addGameUser, {
        show: _unref(gameShow),
        "onUpdate:show": _cache[8] || (_cache[8] = $event => _isRef(gameShow) ? gameShow.value = $event : gameShow = $event),
        title: _unref(gameTitle)
      }, null, 8, ["show", "title"]), _createVNode(_component_van_overlay, {
        show: _unref(shows),
        "z-index": "999"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "wrappers",
          onClick: _cache[9] || (_cache[9] = _withModifiers((...args) => _unref(prompt) && _unref(prompt)(...args), ["stop"]))
        }, [_createElementVNode("div", _hoisted_44, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lotteryType), (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            class: _normalizeClass(item.id == _unref(lotteryTypes) ? 'select' : ''),
            key: index,
            onClick: $event => _unref(selectLottery)(item.id)
          }, [_createElementVNode("div", _hoisted_46, [_createElementVNode("img", {
            src: item.icon,
            alt: ""
          }, null, 8, _hoisted_47), _createElementVNode("p", null, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_48, [_hoisted_49, _createElementVNode("span", _hoisted_50, _toDisplayString(item.times), 1)])], 10, _hoisted_45);
        }), 128))]), _createElementVNode("div", _hoisted_51, [_createVNode(_component_botton, {
          name: "确认",
          onClick: _withModifiers(_unref(prompt), ["stop"])
        }, null, 8, ["onClick"])])])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_wecharList, {
        show: _unref(roomShow),
        "onUpdate:show": _cache[10] || (_cache[10] = $event => _isRef(roomShow) ? roomShow.value = $event : roomShow = $event),
        onSelecRoom: _unref(selecRoom),
        list: _unref(list)
      }, null, 8, ["show", "onSelecRoom", "list"]), _createVNode(_component_van_overlay, {
        show: _unref(showss),
        "z-index": "1000"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[14] || (_cache[14] = _withModifiers($event => _isRef(showss) ? showss.value = false : showss = false, ["stop"]))
        }, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", {
          class: "colse",
          onClick: _cache[11] || (_cache[11] = (...args) => _ctx.colse && _ctx.colse(...args))
        }, _hoisted_54), _createElementVNode("div", _hoisted_55, [_hoisted_56, _createElementVNode("div", _hoisted_57, [_createElementVNode("ul", null, [_createElementVNode("li", {
          onClick: _cache[12] || (_cache[12] = $event => _unref(selecRooms)(1))
        }, _hoisted_60), _createElementVNode("li", {
          onClick: _cache[13] || (_cache[13] = $event => _unref(selecRooms)(2))
        }, _hoisted_63)])])])])])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};